export default __webpack_public_path__ + "static/media/delete-icon.b81b26bc.png";